// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.top-menu-overflow-bar{position:absolute;right:0}`, "",{"version":3,"sources":["webpack://./src/components/top-menus/top-menu/top-menu-overflow-bar.css"],"names":[],"mappings":"AAAA,uBAEC,iBAAkB,CAClB,OACD","sourcesContent":[".top-menu-overflow-bar {\n\t/* right align bar */\n\tposition: absolute;\n\tright: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
